module.exports={Earlier:"それ以前",New:"新規",newNotification:"{newCount} 通の新規通知",newNotifications:"{newCount} 通の新規通知",noNotifications:"通知がありません"};